<script setup lang="ts">
import AppImage from "./AppImage.vue";
</script>

<template>
  <footer id="be-footer" class="be-footer">
    <div class="be-footer__bg1 js-scrollfade"></div>
    <div class="be-footer__inner">
      <div class="be-footer__l js-scrollfade">
        <AppImage
          src="/assets/top/img/footer.png"
          alt="株式会社Bot Express"
          :width="1298"
          :height="1298"
          class="be-resize"
        />
      </div>
      <div class="be-footer__r js-scrollfade">
        <div class="be-footer__logo">
          <AppImage
            src="/assets/common/img/logo_company_white.svg"
            alt="株式会社Bot Express"
            width="448"
            height="57"
            class="be-resize"
          />
        </div>
        <p class="be-footer__address">
          〒105-6923 東京都港区虎ノ門4-1-1 神谷町トラストタワー23階
        </p>
        <div class="be-footer__2clm">
          <div class="be-footer__link">
            <a href="/recruit/" class="be-button--text"
              ><span>一緒に働く仲間を募集しています！</span></a
            >
          </div>
          <ul class="be-footer__sns">
            <li class="be-footer__sns__li">
              <a
                href="https://www.facebook.com/BotExpressInc/"
                target="_blank"
                rel="noopener"
                class="be-hover"
                ><AppImage
                  src="/assets/common/img/ico_facebook.png"
                  alt="facebook"
                  width="64"
                  height="64"
                  class="be-resize"
              /></a>
            </li>
            <li class="be-footer__sns__li">
              <a
                href="https://twitter.com/BotExpressInc"
                target="_blank"
                rel="noopener"
                class="be-hover"
                ><AppImage
                  src="/assets/common/img/ico_twitter.png"
                  alt="twitter"
                  width="64"
                  height="64"
                  class="be-resize"
              /></a>
            </li>
            <li class="be-footer__sns__li">
              <a
                href="https://lin.ee/fwNcITR"
                target="_blank"
                rel="noopener"
                class="be-hover"
                ><AppImage
                  src="/assets/common/img/ico_line.png"
                  alt="line"
                  width="64"
                  height="64"
                  class="be-resize"
              /></a>
            </li>
          </ul>
        </div>

        <div class="be-footer__btn">
          <a
            href="https://form.bot-express.com/inbox"
            target="_blank"
            rel="noopener"
            class="be-button--white"
            ><span>お問い合わせ</span>
            <span class="be-button--white__arrow"></span
          ></a>
        </div>
        <div class="be-footer__foot">
          <div class="be-footer__foot__l">
            <div class="be-footer__foot__link">
              <a
                href="https://bot-express.notion.site/fd5ac5126d4f4b79ae0ad75b8dd923d3"
                target="_blank"
                rel="noopener"
                class="be-textlink"
                >情報セキュリティ方針</a
              >
            </div>
            <div class="be-footer__foot__link">
              <a
                href="https://bot-express.notion.site/a37097a3f3934ac29dadbf6e263987fc"
                target="_blank"
                rel="noopener"
                class="be-textlink"
                >個人情報保護基本方針</a
              >
            </div>
            <div class="be-footer__foot__link">
              <a
                href="https://bot-express.notion.site/1ffd5f46561980e599d3ef618d5c345f"
                target="_blank"
                rel="noopener"
                class="be-textlink"
                >ウェブサイト利用規約</a
              >
            </div>
            <div class="be-footer__foot__link"></div>
            <div class="be-footer__foot__cr">Copyright © Bot Express Inc.</div>
          </div>
          <div class="be-footer__foot__r">
            <span
              ><AppImage
                src="/assets/common/img/isms.png"
                alt="iso認証"
                :width="229"
                :height="86"
                class="be-resize"
            /></span>
          </div>
        </div>
      </div>
    </div>
    <div class="be-footer__bg2">
      <AppImage
        src="/assets/common/img/footer_text.svg"
        alt="世界からめんどくさいをなくせ。"
        width="1600"
        height="80"
        class="be-resize"
      />
    </div>
  </footer>
</template>
